module.exports = __webpack_public_path__ + "static/media/centivo-logo.fa489bb1.svg";